<template>
    <simple-layout>
        <basic-card>
            <template slot="header">
                {{ $t('reconciliation.cashEvent') }}
            </template>
            <simple-list object-name="cashEvent" query-store-name="cashEvent" :columns="cashEventColumns"
                         :config="cashEventListConfig"
                         @focused-changed="cashEventFocused">
                <reconciliation-account-balance-items-card
                  :cash-event="focusedCashEvent"
                  :key="focusedCashEvent.id"
                  v-if="focusedCashEvent != null"/>
            </simple-list>
        </basic-card>
    </simple-layout>
</template>

<script>
import SimpleLayout from "../components/layout/SimpleLayout";
import BasicCard from "../components/layout/BasicCard";
import SimpleList from "../components/lists/SimpleList";
import { mapGetters } from "vuex";
import QueryUtils from "../utils/QueryUtils";
import FilterForm from "../components/filters/FilterForm";
import SimpleButton from "../components/button/SimpleButton";
import DataTable from "../components/table/DataTable";
import ReconciliationAccountBalanceItemsCard from "../cards/ReconciliationAccountBalanceItemsCard";
// import AccountBalanceItemStore from "../stores/account-balance-item-store";

export default {
    name: "ReconciliationView",
    components: {
        ReconciliationAccountBalanceItemsCard,
        DataTable, SimpleButton, FilterForm, SimpleList, BasicCard, SimpleLayout
    },
    computed: {
        ...mapGetters({
            "account": "banking/account",
            "currencies": "currencies/currenciesOptions",
            "accounts": "banking/accounts",
            "accountBalanceItems": "accountBalanceItems/accountBalanceItems"
        }),
        queryDefinition() {
            return QueryUtils.getByType("accountBalanceItem", {
                currencies: this.currencies,
                accounts: this.accounts
            })
        }
    },
    methods: {
        cashEventFocused(focusedCashEvent) {
            if (focusedCashEvent == null || focusedCashEvent == undefined) {
                this.focusedCashEvent = null;
                this.searchQuery = {parameters: {}}
                return;
            }
            this.focusedCashEvent = focusedCashEvent;
        }
    },
    data() {
        return {
            refreshDate: new Date().getTime(),
            searchQuery: {parameters: {}},
            focusedCashEvent: null,

            cashEventListConfig: {
                tableConfiguration: {
                    enableCheck: false
                }
            },
            cashEventColumns: [
                {
                    caption: "Id",
                    datum: d => d.id.substr(0, 5)
                },
                {
                    caption: this.$t('type'),
                    datum: d => d.type
                },
                {
                    caption: this.$t('status'),
                    datum: d => d.status
                },
                {
                    caption: this.$t('source'),
                    datum: d => d.source
                },
                {
                    caption: this.$t('accountBalancesItems.amount'),
                    datum: d => this.$formats.formatAmount(d.amount / 1000000)
                },
                {
                    caption: this.$t('accounts.currency'),
                    datum: d => d.currency
                },
                {
                    caption: this.$t('accounts.name'),
                    datum: d => this.account(d.account).name
                },
                {
                    caption: this.$t('reconciliation.transactionReference'),
                    datum: d => d.transactionReference
                }
            ]
        }
    },
    mounted() {
        // this.$store.registerModule("reconciliation-items", AccountBalanceItemStore());

    },
    beforeDestroy() {
        // this.$store.unregisterModule("reconciliation-items");
    }
}
</script>

<style scoped>

</style>